<template>
  <div class="achievements">
    <div class="title_text">
      Мои достижения
    </div>
    <div
        class="achievements-card"
        v-for="(ach, index) in achievements" :key="index"
    >
      <AchievementCard
          :title="ach.title"
          :current="ach.progress"
          :total="ach.target_value"
          :description="ach.description"
          :isAchieved="ach.achieved"
      />
    </div>

  </div>
</template>

<script setup>
import AchievementCard from './AchievementCard'
import { computed, onMounted } from 'vue'
import { useUserStore } from '@/stores/user/userStore'
import { getTelegramUser } from '@/helpers/telegram'
const userTg = getTelegramUser()

onMounted(() => {
  if (userTg) user.setUser(userTg)
})
const user = useUserStore()
const achievements = computed(() => {
  return user.achievements || []
})

</script>

<style lang="scss" scoped>
  .achievements {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 140px);
    overflow-y: auto;
    padding:10px;
  }
  .achievements > *:not(:last-child) {
    margin-bottom: 20px; // или right для горизонтального
  }
</style>
